export function padLeft(num: number, pad = '00000'): string {
    const numberAsString = num + '';
    return pad.substring(0, pad.length - numberAsString.length) + numberAsString;
}
